import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null=checking, false=guest, obj=admin
  useEffect(() => {
    const token = localStorage.getItem("sonia_admin_token");
    if (!token) {
      setAdmin(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => {
        localStorage.removeItem("sonia_admin_token");
        setAdmin(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sonia_admin_token", data.token);
    setAdmin(data.user);
    return data.user;
  };
  const logout = () => {
    localStorage.removeItem("sonia_admin_token");
    setAdmin(false);
  };

  return <AuthContext.Provider value={{ admin, login, logout }}>{children}</AuthContext.Provider>;
};
